export class PreInvoicingAlertModel {
    alertType: number = 0;
    message: string = '';
}